import { setDefaultErrorMessages } from 'last-validator'

/**
 * last-validator ships every default message as an empty string, and its `reject` resolves to
 * `message || true`. An `isRequired()` failure therefore produced the boolean `true`, which
 * forms rendered literally as the word "true" under the field — across all ~194 call sites
 * that never passed a message of their own.
 *
 * Setting the defaults once here fixes every form; a validator that passes its own message is
 * unaffected.
 */
export default defineNuxtPlugin(() => {
    setDefaultErrorMessages({
        isRequired: 'Toto pole je povinné.',
        isNumeric: 'Zadajte prosím číslo.',
        isEmail: 'Zadajte prosím platný e-mail.',
        isLessThan: 'Hodnota je príliš vysoká.',
        isLessOrEqualThan: 'Hodnota je príliš vysoká.',
        isGreaterThan: 'Hodnota je príliš nízka.',
        isGreaterOrEqualThan: 'Hodnota je príliš nízka.',
        hasMinLength: 'Zadajte prosím dlhšiu hodnotu.',
        hasMaxLength: 'Zadajte prosím kratšiu hodnotu.'
    })
})
